import {cloudinary} from './default'

export const updateTrackingParam = (srcset) => {
    const splits = srcset.split(' ')
    const newSrcset = splits.map((split) => {
        if (split.lastIndexOf('?') > -1) {
            return split.substring(0, split.lastIndexOf('?')) + cloudinary.CLD_TRACKING_PARAM
        } else {
            return split
        }
    })
    return newSrcset.join(' ')
}
